// framework

import { arraySize } from '@/components/utils';

/**
 * type guard (https://stackoverflow.com/questions/64121881/using-a-type-as-a-parameter-typescript)
 */
type Guard<T> = (x: any) => x is T;

/**
 * sanitize query parameters - multi-value
 * @param paramValue query parameter value to validate
 * @param validateType guard used for validation
 * @param def default value if validation fails
 */
export function sanitize<T extends string>(paramValue: any, def: T[], validateType: Guard<T>): T[] {
  if (paramValue) {
    //console.debug('[sanitizer] check', paramValue);
    let values: Array<string> | undefined;
    if (typeof paramValue === 'string') values = [paramValue as string];
    if (paramValue instanceof Array) values = paramValue;

    if (values && !values.find((item) => !validateType(item))) {
      //console.debug('[sanitizer] valid', values);
      return values as T[];
    }
  }
  //console.warn('[sanitizer] invalid param. using default:', def);
  return def;
}

/**
 * sanitize query parameters - single-value
 * @param paramValue query parameter value to validate
 * @param validateType guard used for validation
 * @param def default value if validation fails
 */
export function sanitize1val<T extends string>(paramValue: string | unknown, validateType: Guard<T>, def: T): T {
  const x = sanitize(paramValue, [def], validateType);
  if (x && arraySize(x) > 0) return x[0];
  //console.warn('[sanitizer1] invalid param. using default:', def);
  return def;
}

// predefined types -------------

type ID = string;

// predefined guards -------------

export function isValidID(x: any): x is ID {
  return typeof x === 'string' && /^[a-zA-Z0-9-_]{2,64}$/.test(x);
}


